import React from 'react';
import BarChart from 'react-apexcharts';

const Bar = () => {
  const options = {
    chart: {
      type: 'bar',
      height: 430,
      zoom: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: ['#313265', '#fab546'], // Custom colors for series
    dataLabels: {
      enabled: false,
      offsetX: -6,
      style: {
        fontSize: '12px',
        colors: ['#fff'],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: ['Real Do', 'SAI Branding'],
      
    },
    legend: {
      show: true,
      position: 'bottom',
    },
  };

  const series = [
    {
      name: 'Facebook & Instagram',
      data: [44, 55],
    },
    {
      name: 'Other',
      data: [53, 32],
    },
  ];

  return (
    <div id="chart">
      <BarChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default Bar;
